import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconPickerService } from './icon-picker.service';
import { IconPickerComponent } from './icon-picker.component';
import { IconPickerDirective } from './icon-picker.directive';
import { TextDirective } from './text.directive';
import { SearchIconPipe } from './search-icon.pipe';


export class IconPickerModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports        : [
    CommonModule
  ],
  providers      : [
    IconPickerService
  ],
  declarations   : [
    IconPickerComponent,
    IconPickerDirective,
    TextDirective,
    SearchIconPipe
  ],
  exports        : [
    IconPickerDirective
  ],
  entryComponents: [
    IconPickerComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
